import { createContext, useEffect, useState } from "react";
import { useContext } from "react";
import getScreenSize from "../utils/screenHelper";


const ScreenCtx = createContext();

const ScreenProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [screenSize, setScreenSize] = useState(null);
  const [top, setTop] = useState(0)
  const [pages, setPages] = useState(0);

  // useEffect(() => {
  //   const setDevice = async () => {
  //     const size = getScreenSize();
  //     setScreenSize(size);
  //     size < 500 ? setIsMobile(true) : null
  //   };
  //   setDevice();
  // }, []);

  return (
    <ScreenCtx.Provider 
      value={{ 
        screenSize, 
        isMobile, 
        setIsMobile,
        top,
        setTop,
        pages,
        setPages
      }}>
      {children}
    </ScreenCtx.Provider>
  )
};

const useScreen = () => {
  const ctx = useContext(ScreenCtx);

  if(ctx === undefined) {
    throw new Error('useScreen can only be called within the children of screen context provider');
  };
  return ctx;
}

export {ScreenProvider, ScreenCtx, useScreen};